// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"144":"eb479494","2622":"73799308","7986":"e7e6c50a"}[chunkId] + ".chunk.css";
};